import { FURNITURE_OTHER_TYPE_DESKTOP } from "~/constants/item"

export const state = (): ItemCategory[] => []

export const GET_ITEMS = "getItems"
export const GET_ITEMS_WITH_CUSTOM_ITEM = "getItemsWithCustomItem"

export const getters = {
  [GET_ITEMS]: (state: ItemCategory[]) => (categoryString: string) => {
    let items

    if ((items = state.find(itemCategory => itemCategory.key === categoryString))) {
      if (items && items.items !== undefined) {
        return items.items
      }

      return []
    } else {
      return []
    }
  },
  [GET_ITEMS_WITH_CUSTOM_ITEM]: (state: ItemCategory[]) => (categoryString: string) => {
    let items

    if ((items = state.find(itemCategory => itemCategory.key === categoryString))) {
      if (items && items.items !== undefined) {
        const result = items.items.slice()
        result.push(FURNITURE_OTHER_TYPE_DESKTOP)
        return result
      }

      return []
    } else {
      return []
    }
  }
}

export const _SET_RESPONSE = "setResponse"
export const _UPDATE_ITEM_CATEGORY = "updateItemCategory"

export const mutations = {
  [_SET_RESPONSE](state: ItemCategory[], response: ItemCategory) {
    state.push(response)
  },
  [_UPDATE_ITEM_CATEGORY](state: ItemCategory[], itemCategory: ItemCategory) {
    const key: string = itemCategory.key
    const item: Item = itemCategory.items[0]
    const itemsIndex = state.findIndex(itemCategory => itemCategory.key === key)
    const items: Item[] = state[itemsIndex].items
    const index: number = items.findIndex(
      it => it.fake_id === item.fake_id && it.location_id === item.location_id
    )

    item.fake_id = GET_FAKE_ID(item)
    state[itemsIndex].items[index] = item
  }
}

export const CATEGORY_ITEMS = "categoryItems"

export const actions = {
  [CATEGORY_ITEMS]({ state, commit }, categoryParams) {
    commit(_SET_RESPONSE, categoryParams)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
